import { FormattedMessage } from 'react-intl';

import { paths } from '@/lib/paths';
import * as AM from '@/messages/myAccount';

import { ReactComponent as Addresses } from '@/assets/my_account/icons/addresses.svg';
import { ReactComponent as AddressesActive } from '@/assets/my_account/icons/addresses_active.svg';
// ‘My Preferred Boutique’ as this out of scope for US/CA Go Live.
// import { ReactComponent as Boutique } from '@/assets/my_account/icons/boutique.svg';
// import { ReactComponent as BoutiqueActive } from '@/assets/my_account/icons/boutique_active.svg';
import { ReactComponent as MyAccount } from '@/assets/my_account/icons/my_details.svg';
import { ReactComponent as MyAccountActive } from '@/assets/my_account/icons/my_details_active.svg';
import { ReactComponent as MyPreferences } from '@/assets/my_account/icons/my_preferences.svg';
import { ReactComponent as MyPreferencesActive } from '@/assets/my_account/icons/my_preferences_active.svg';
import { ReactComponent as OnGoingOrder } from '@/assets/my_orders/icons/on_going_order.svg';
import { ReactComponent as OnGoingOrderActive } from '@/assets/my_orders/icons/on_going_order-active.svg';
import { ReactComponent as OrderHistory } from '@/assets/my_orders/icons/order_history.svg';
import { ReactComponent as OrderHistoryActive } from '@/assets/my_orders/icons/order_history-active.svg';
import { ReactComponent as ReturnHistory } from '@/assets/my_orders/icons/return_history.svg';
import { ReactComponent as ReturnHistoryActive } from '@/assets/my_orders/icons/return_history-active.svg';
import { ReactComponent as ServiceHistory } from '@/assets/my_orders/icons/service_history.svg';
import { ReactComponent as ServiceHistoryActive } from '@/assets/my_orders/icons/service_history-active.svg';
import { ReactComponent as TradeInHistory } from '@/assets/my_orders/icons/trade_in_history.svg';
import { ReactComponent as TradeInHistoryActive } from '@/assets/my_orders/icons/trade_in_history-active.svg';

const onGoingOrderConf = {
  activeIcon: (
    <OnGoingOrderActive
      data-test-id='ORDERS_MENU_OnGoingOrderActive'
      height={24}
    />
  ),
  icon: <OnGoingOrder data-test-id='ORDERS_MENU_OnGoingOrder' height={24} />,
  label: (
    <FormattedMessage {...AM.myAccountMessages.accountOrdersMenuOngoing} />
  ),
  path: paths.myAccount.myOrders.ongoingOrder.asPath(),
};
const orderHistoryConf = {
  activeIcon: (
    <OrderHistoryActive
      data-test-id='ORDERS_MENU_OrderHistoryActive'
      height={24}
    />
  ),
  icon: <OrderHistory data-test-id='ORDERS_MENU_OrderHistory' height={24} />,
  label: (
    <FormattedMessage {...AM.myAccountMessages.accountOrdersMenuOrderHistory} />
  ),
  path: paths.myAccount.myOrders.orderHistory.asPath(),
};
const returnHistroyConf = {
  activeIcon: (
    <ReturnHistoryActive
      data-test-id='ORDERS_MENU_ReturnHistoryActive'
      height={24}
    />
  ),
  icon: <ReturnHistory data-test-id='ORDERS_MENU_ReturnHistory' height={24} />,
  label: <FormattedMessage {...AM.myAccountMessages.accountOrdersMenuReturn} />,
  path: paths.myAccount.myOrders.returnHistory.asPath(),
};
const serviceHistoryConf = {
  activeIcon: (
    <ServiceHistoryActive
      data-test-id='ORDERS_MENU_ServiceHistoryActive'
      height={24}
    />
  ),
  icon: (
    <ServiceHistory data-test-id='ORDERS_MENU_ServiceHistory' height={24} />
  ),
  label: (
    <FormattedMessage {...AM.myAccountMessages.accountOrdersMenuService} />
  ),
  path: paths.myAccount.myOrders.serviceHistory.asPath(),
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const tradeInHistoryConf = {
  activeIcon: (
    <TradeInHistoryActive
      data-test-id='ORDERS_MENU_TradeInHistoryActive'
      height={24}
    />
  ),
  icon: (
    <TradeInHistory data-test-id='ORDERS_MENU_TradeInHistory' height={24} />
  ),
  label: (
    <FormattedMessage {...AM.myAccountMessages.accountOrdersMenuTradeIn} />
  ),
  path: paths.myAccount.myOrders.tradeInHistory.asPath(),
  disabled: true,
};

const myPreferencesConf = {
  activeIcon: (
    <MyPreferencesActive
      data-test-id='MY_DETAILS_MENU_MyPreferencesActive'
      height={24}
    />
  ),
  icon: (
    <MyPreferences data-test-id='MY_DETAILS_MENU_MyPreferences' height={24} />
  ),
  label: <FormattedMessage {...AM.myAccountMessages.myPreferences} />,
  path: paths.myAccount.myDetails.myPreferences.asPath(),
};

const myAccountConf = {
  activeIcon: (
    <MyAccountActive
      data-test-id='MY_ADDRESSES_MENU_MyAccountActive'
      height={24}
    />
  ),
  icon: <MyAccount data-test-id='MY_ADDRESSES_MENU_MyAccount' height={24} />,
  label: <FormattedMessage {...AM.myAccountMessages.detailsMenuAccount} />,
  path: paths.myAccount.myDetails.myAccount.asPath(),
};

const addressConf = {
  activeIcon: (
    <AddressesActive
      data-test-id='MY_DETAILS_MENU_AddressesActive'
      height={24}
    />
  ),
  icon: <Addresses data-test-id='MY_DETAILS_MENU_Addresses' height={24} />,
  label: (
    <FormattedMessage {...AM.myAccountMessages.accountDetailsMenuAddresses} />
  ),
  path: paths.myAccount.myAddresses.history.asPath(),
};

// ‘My Preferred Boutique’ as this out of scope for US/CA Go Live.
// const boutiqueConf = {
//   activeIcon: (
//     <BoutiqueActive
//       data-test-id='MY_ADDRESSES_MENU_BoutiqueActive'
//       height={24}
//     />
//   ),
//   icon: <Boutique data-test-id='MY_ADDRESSES_MENU_Boutique' height={24} />,
//   label: <FormattedMessage {...AM.myAccountMessages.myPreferredBoutique} />,
//   path: paths.myAccount.myDetails.myBoutiques.asPath(),
//   disabled: true,
// };

export const ORDERS_MENU = [
  onGoingOrderConf,
  orderHistoryConf,
  returnHistroyConf,
  serviceHistoryConf,
  // Temporarily remove invalid menu item
  // tradeInHistoryConf,
];

// TODO Add after views are created
export const MY_DETAILS_MENU = [
  myPreferencesConf,
  myAccountConf,
  addressConf,
  // TEMPORARY REMOVED, TO BE READDED
  // boutiqueConf,
];

export const MY_ADDRESSES_MENU = [
  myPreferencesConf,
  myAccountConf,
  addressConf,
  // ‘My Preferred Boutique’ as this out of scope for US/CA Go Live.
  // boutiqueConf,
];

export type NavigationType = 'myOrders' | 'myDetails' | 'myAddresses';
